// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incyia-select-create {
  position: sticky;
  bottom: 0;
  margin-top: 4px;
  padding: 4px;
  background: #fff;
  border-top: 1px solid #e3ebec;
}

.incyia-select-create button {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: 0;
  border-radius: 6px;
  background: #eef8f6;
  color: #076b5c;
  font: inherit;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
}

.incyia-select-create button:hover,
.incyia-select-create button:focus-visible {
  background: #d9f1ec;
  outline: none;
}

.incyia-select-create-plus {
  display: inline-grid;
  place-items: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #0d9b87;
  color: #fff;
  font-size: 14px;
  line-height: 1;
}

.incyia-select-create-search {
  overflow: hidden;
  color: #5f7484;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/CreateOptionMenu.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".incyia-select-create {\n  position: sticky;\n  bottom: 0;\n  margin-top: 4px;\n  padding: 4px;\n  background: #fff;\n  border-top: 1px solid #e3ebec;\n}\n\n.incyia-select-create button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 10px;\n  border: 0;\n  border-radius: 6px;\n  background: #eef8f6;\n  color: #076b5c;\n  font: inherit;\n  font-weight: 700;\n  text-align: left;\n  cursor: pointer;\n}\n\n.incyia-select-create button:hover,\n.incyia-select-create button:focus-visible {\n  background: #d9f1ec;\n  outline: none;\n}\n\n.incyia-select-create-plus {\n  display: inline-grid;\n  place-items: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #0d9b87;\n  color: #fff;\n  font-size: 14px;\n  line-height: 1;\n}\n\n.incyia-select-create-search {\n  overflow: hidden;\n  color: #5f7484;\n  font-weight: 500;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
